import { IPagedRequest } from "./request.model";
import { IUser } from "./users.model";

export interface IPartnerListReq extends IPagedRequest{
    status? : string | null
}

export interface IPartner{
    _id: string
    user: IPartnerUser
    kycStatus: string
    kycVerificationResult: IKYCVerificationResult
    partnershipGoals: string
    targetAudience: string
    marketingPlan: string
    socialMedia: IPartnerSocialMedia[]
    status: string
    submittedAt: Date
    reviewedAt: Date
    reviewedBy: string
    adminNotes: string
    canApprove: boolean
    stripeAccountId: string | null
    stripeAccountSetupCompleted: boolean
    selected: boolean
}

export interface IPartnerApiData {
  applications: IPartner[];
  totalCount: number;
  hasMore: boolean;
}

export interface IPartnerUser{
    _id: string
    name: string
    email: string
}

export interface IKYCVerificationResult{
    verified: boolean
}

export interface IPartnerSocialMedia{
    instagram: string
    facebook: string
    twitter: string
}

export enum PartnerStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
}